import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../dataStore/reducers/reducerType'
import { StructuredPresenterInterface } from '../../dataStore/selectors/structuredSelectPresenter/types'
import SpotlightControls from './SpotlightControls'
import selectFocusedPresenterDetails from '../../dataStore/selectors/selectFocusedPresenterDetails'
import constants from '@bt-react/constants'
import { openSpotlightMediaDrawer, closeSpotlightMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import { IconType } from '@bt-react/components/Icon'
import { OBSERVER } from '../../dataStore/constants/roles'

const SpotlightControlsIndex: React.FunctionComponent = () => {
  const focusedPresenterDetails = useSelector((state: State) => selectFocusedPresenterDetails(state)) as StructuredPresenterInterface
  const autoSpotlight = useSelector((state: State) => state.syncUi.autoSpotlight) as boolean
  const mediaDrawerOpen = useSelector((state: State) => state.ui.selectedDrawer === constants.drawerType.SPOTLIGHT) as boolean
  const isObserver = useSelector((state: State) => state.config.role === OBSERVER) as boolean
  const dispatch = useDispatch()

  const onClick = () => mediaDrawerOpen ? dispatch(closeSpotlightMediaDrawer()) : dispatch(openSpotlightMediaDrawer())

  const spotlightIcon = () => focusedPresenterDetails?.name ? IconType.iconName.user : IconType.iconName.usersClass

  return <SpotlightControls
    onClick={onClick}
    focusedOnPresenterName={focusedPresenterDetails?.name}
    iconName={focusedPresenterDetails ? spotlightIcon() : IconType.iconName.th}
    autoSpotlight={autoSpotlight}
    isObserver={isObserver}
  />
}

export default SpotlightControlsIndex